module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"placeholder":"請寫評論","submit":"註冊","cancel":"取消","create_comment_failure":"留言發表時發生錯誤。","edit_comment_failure":"留言編輯時發生錯誤。","confirm_cancel_edit":"確定要取消評論修改嗎？"}}')
  delete Component.options._Ctor
}
